import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import {
  Spin,
  Row,
  Col,
  Button,
  Input,
  Modal,
  Radio,
  Tabs,
  Form,
  Select,
  message,
  Breadcrumb,
  Typography,
  Tooltip,
} from 'antd'
import {
  ExclamationCircleOutlined,
  EditOutlined,
  CopyOutlined,
  CheckCircleFilled,
  CloseCircleOutlined,
} from '@ant-design/icons'
import util from '../../util/util'
import FullfillmentTable from './fullfillment.table'
import '../../css/fulfillment.scss'
import { useLocation, useParams, useHistory } from 'react-router'
import { fetchUsers } from '../../store/action/user.action'
import { messageGroupBy } from '../../store/action/actioncases.action'
import {
  getFullfillmentViewDevices,
  setFullfillmentDevices,
  updateDeviceOrder,
  markAsShipped,
  updateAddress,
  updateTracPatchFulfillment,
} from '../../store/action/device.action'
import FullfillmentViewTable from './fullfillment.view.table'
import { FullfillmentRowSelect } from '../../store/action/callback.action'
import { constants } from '../../constants'
import { getActiveAssignedDevices } from '../../store/action/patient.action'
import _ from 'lodash'
import moment from 'moment'
const FullfillmentView = (props) => {
  const initialAddress = {
    addressline1: 'NA',
    addressline2: 'NA',
    city: 'NA',
    state: 'NA',
    zip: 'NA',
    country: 'US',
  }
  const { TextArea } = Input
  const { Text, Title } = Typography
  const [form] = Form.useForm()
  var history = useHistory()
  const params = useParams()
  const fulfillmentid = params.fulfillmentid
  const [gateway, setGateway] = useState({ edit: false, gateway_id: '' })
  const [tracking, setTracking] = useState({ edit: false, url: '' })
  const [tracpatch, setTracpatch] = useState({ white_short: '', blue_short: '', leg_side: '' })
  const [formAddress, setFormAddress] = useState(initialAddress)
  const [note, setNote] = useState({ edit: false, note: '' })
  const [shippingaddress, setShippingAddress] = useState(false)
  const [isStateAvailable, setIsStateAvailble] = useState(true)
  const [copied, setCopied] = useState({
    address: false,
    gateway: false,
    patient: false,
  })
  const [trackingErrorMsg, setTrackingErrorMsg] = useState('')
  const [gatewayErrorMsg, setGatewayErrorMsg] = useState('')

  const [address, setAddress] = useState({})
  const isTracPatch =
    props.fullfillmentDevices?.devices?.length > 0 &&
    props.fullfillmentDevices.devices.every((d) => d.device_type === 'tracpatch')

  useEffect(() => {
    props.getFullfillmentViewDevices(fulfillmentid)
  }, [])

  useEffect(() => {
    if (props.fullfillmentDevices) {
      const { gateway_id, tracking_link, address, patient, devices } = props.fullfillmentDevices
      props.getActiveAssignedDevices(patient?._id)
      setGateway({ ...gateway, url: gateway_id })
      setTracking({ ...tracking, url: tracking_link })
      setNote({ ...note, note: props.fullfillmentDevices.note })
      formatAddressData()
      const isTP = devices?.length > 0 && devices.every((d) => d.device_type === 'tracpatch')
      if (isTP) {
        const d = devices[0]
        setTracpatch({
          white_short: d.white_short || '',
          blue_short: d.blue_short || '',
          leg_side: d.leg_side || '',
        })
        const keys = devices.map((d) => d.deviceid)
        props.onRowSelect({ key: keys, row: devices.map((d) => ({ ...d, key: d.deviceid })) })
      }
    }
  }, [props.fullfillmentDevices])

  // useEffect(() => {
  //     console.log('formAddress', formAddress, initialAddress)
  //     if (!_.isEqual(formAddress, initialAddress)) {
  //          handleDeviceOrder()
  //     }
  // }, [formAddress])

  const hasOnlyNAExceptCountry = (obj) => {
    return Object.entries(obj).every(([key, value]) => {
      if (key === 'country') return true // Skip country
      return value === 'NA' || value === ''
    })
  }

  const handleDeviceOrder = async () => {
    const addressData = form.getFieldValue()
    let updates = {
      _id: props.fullfillmentDevices._id,
      gateway_url: gateway.url
        ? gateway.url.replaceAll(' ', '').replaceAll('-', '')
        : gateway.url,
      shipping_address: addressData,
      tracking_url: tracking.url,
      note: note.note,
    }
    const response = await props.updateDeviceOrder(updates)

    // if (response) props.getFullfillmentViewDevices(fulfillmentid)
    setGateway((prev) => ({ url: gateway.url, edit: false }))
    setTracking((prev) => ({ ...prev, edit: false }))
    setNote((prev) => ({ ...prev, edit: false }))
    setShippingAddress(false)
    return response
  }
  const copyToClipboard = (data, type) => {
    navigator.clipboard
      .writeText(data)
      .then(() => {
        setCopied({
          ...copied,
          address: type == 'address',
          gateway: type == 'gateway',
          patient: type == 'patient',
        })
        setTimeout(() => {
          setCopied({ address: false, gateway: false, patient: false })
        }, 2000)
      })
      .catch((err) => {
        message.error('Failed to copy')
      })
  }
  const stringifyAddress = () => {
    let addressStr = ''
    let { address } = props.fullfillmentDevices
    if (address) {
      delete address.__typename
      Object.keys(address).map((k) => {
        if (address[k] != '') {
          addressStr += address[k] + '\n'
        }
      })
    }
    return addressStr
  }
  const copyAddress = () => {
    copyToClipboard(stringifyAddress(), 'address')
  }
  const copyGateway = () => {
    copyToClipboard(gateway.url, 'gateway')
  }
  const copyPatient = () => {
    copyToClipboard(props.fullfillmentDevices?.patient?._id, 'patient')
  }
  const handleShipped = async () => {
    // For TracPatch, auto-populate devicesids from props since devices are auto-selected
    let devicesids = props.fullfillmentRequests?.key
    if (isTracPatch && (!devicesids || devicesids.length === 0)) {
      devicesids = props.fullfillmentDevices?.devices?.map((d) => d.deviceid) ?? []
    }
    const shippedObj = {
      _id: props.fullfillmentDevices?._id,
      devicesids,
    }
    if (!shippedObj.devicesids || shippedObj.devicesids.length === 0) {
      message.error('Please select at least one device from the list above')
      return
    }
    const validateSaveAddress = await handleSaveAddress()
    if (!validateSaveAddress) {
      message.error('Please fill in the shipping address')
      return
    }
    if (!validAllRequiredField()) {
      message.error(
        isTracPatch
          ? 'Please fill in WHITE serial, BLUE serial, Leg Side and Tracking URL'
          : 'Please fill in Gateway ID and Tracking URL'
      )
      return
    }
    if (isTracPatch) {
      const device = props.fullfillmentDevices.devices[0]
      const tpResult = await props.updateTracPatchFulfillment({
        _id: fulfillmentid,
        deviceid: device.deviceid,
        white_short: tracpatch.white_short.trim().toUpperCase(),
        blue_short: tracpatch.blue_short.trim().toUpperCase(),
        leg_side: tracpatch.leg_side,
      })
      if (!tpResult) return
    }
    const deviceOrderResponse = await handleDeviceOrder()
    if (deviceOrderResponse) {
      const status = await props.markAsShipped(shippedObj)
      if (status) {
        props.onRowSelect({})
        setTimeout(() => {
          history.push('/fulfillment')
        }, 2000)
      }
    }
  }

  const handleSaveAddress = async () => {
    try {
      const values = await form.validateFields()
      setAddress({ ...formAddress, ...values })
      setFormAddress({ ...formAddress, ...values })
      setShippingAddress(false)
      return true
    } catch (errorInfo) {
      console.log('Form validation failed: ', errorInfo)
      return false
    }
  }
  const closeEditAddress = () => {
    setShippingAddress(false)
    form.resetFields()
  }
  const gatewayIdPrompt = async () => {
    Modal.confirm({
      title: 'Are you sure you want to update the Gateway ID?',
      content: 'Once the gateway updated, the older devices wont work.',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {},
      onCancel: () => setGateway({ ...gateway, open: false }),
    })
  }

  const formatAddressData = () => {
    if (props.fullfillmentDevices?.address) {
      const { address } = props.fullfillmentDevices
      let addressLines = address.shipping_address.split(',')
      // console.log('props.fullfillmentDevices', props.fullfillmentDevices, addressLines)
      let addressData = {
        addressline1: addressLines.length > 1 ? addressLines[0] : 'NA',
        addressline2: addressLines.length > 1 ? addressLines[1] : 'NA',
        city: address.shipping_city,
        state: address.shipping_state,
        zip: address.shipping_zip_code,
        country: address.country,
      }
      setAddress(addressData)
      form.setFieldsValue(addressData)
    }
  }

  const renderShipping = () => {
    return (
      <>
        <Row className='header-text '>
          {' '}
          Shipping Address
          {/* {!shippingaddress && <span style={{ marginLeft: 10 }}><EditOutlined size={16} onClick={() => setShippingAddress(true)} /></span>} */}
          {!shippingaddress && (
            <span style={{ marginLeft: 10 }}>
              <CopyOutlined onClick={copyAddress} />
            </span>
          )}
          {/* {shippingaddress && <span style={{ marginLeft: 10 }} ><CheckCircleFilled onClick={handleSaveAddress} /></span>}
                    {shippingaddress && <span style={{ marginLeft: 10 }} ><CloseCircleOutlined onClick={closeEditAddress} /></span>} */}
          {copied.address && <Text className='copied-text'>Copied!</Text>}
        </Row>
        <fieldset className='fulfillmentContainer shipping'>
          <Form form={form} initialValues={address}>
            <Row gutter={[32, 8]}>
              <Col span={24}>
                <Form.Item
                  label='ADDRESS LINE'
                  name='addressline1'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please enter address.',
                    },
                  ]}
                >
                  <Input style={{ width: '100%' }} maxLength={150} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[32, 8]}>
              <Col span={12}>
                <Form.Item
                  label='CITY'
                  name='city'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please select city name.',
                    },
                  ]}
                >
                  <Input maxLength={50} />
                </Form.Item>
                <Form.Item
                  label='ZIP CODE'
                  name='zip'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please enter zip code',
                    },
                  ]}
                >
                  <Input maxLength={50} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label='STATE'
                  name='state'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please select state.',
                    },
                  ]}
                >
                  <Select
                    style={{ textAlign: 'start' }}
                    defaultValue={'Alabama'}
                  >
                    {constants.USA_STATE.map((s) => {
                      return <Select.Option value={s}>{s}</Select.Option>
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label='COUNTRY'
                  name='country'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please select country.',
                    },
                  ]}
                >
                  <Select
                    style={{ textAlign: 'start' }}
                    defaultValue={'US'}
                    onChange={(e) => {
                      e == 'US'
                        ? setIsStateAvailble(true)
                        : setIsStateAvailble(false)
                    }}
                  >
                    {constants.COUNTRYS.map((c) => {
                      return (
                        <Select.Option value={c.code}>{c.name}</Select.Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </fieldset>
      </>
    )
  }

  const renderOrderDetails = () => {
    const { customer, patient, createdAt } = props.fullfillmentDevices
    return (
      <>
        <Row className='header-text '> Order Details</Row>
        <fieldset className='fulfillmentContainer'>
          <Row justify={'center'}>
            <Col flex={'100%'}>
              <Row gutter={25}>
                <Col flex={'auto'}>
                  <Row className='order-label'>Clinics:</Row>
                  <Row className='order-val'>
                    {customer?.name ? customer.name : 'NA'}
                  </Row>

                  <Row className='order-label'>
                    Patient:
                    <span style={{ marginLeft: 10 }}>
                      {/* <CopyOutlined onClick={copyPatient} /> */}
                    </span>
                    {/* {copied.patient && <Text className='copied-text'>Copied!</Text>} */}
                  </Row>
                  <Row className='order-val'>
                    {patient
                      ? _.capitalize(patient.firstname) +
                        ' ' +
                        (patient.lastname
                          ? _.capitalize(patient.lastname)
                          : 'NA')
                      : 'NA'}
                     {!patient.active && <span style={{color:'red',marginLeft:10,fontWeight:'bold'}}>( Inactive )</span>} 
                  </Row>

                  <Row className='order-label'>
                    Patient id:
                    <span style={{ marginLeft: 10 }}>
                      <CopyOutlined onClick={copyPatient} />
                    </span>
                    {copied.patient && (
                      <Text className='copied-text'>Id Copied!</Text>
                    )}
                  </Row>
                  <Row className='order-val'>
                    {patient ? props.fullfillmentDevices?.patient?._id : 'NA'}
                  </Row>
                  <Row className='order-label'>Consent:</Row>
                  <Row className='order-val'>
                    {patient && props.fullfillmentDevices?.patient?.consent
                      ? `Yes (${moment(props.fullfillmentDevices?.patient?.patientconsent).format('MM/DD/YYYY hh:mm A')})`
                      : 'No'}
                  </Row>
                  
                  <Row className='order-label'>Fulfillment Type :</Row>
                  <Row className='order-val'>
                    {props.fullfillmentDevices.isnew ? "Reorder":"New"}
                  </Row>
                </Col>
                <Col flex={'auto'}>
                  <Row className='order-label'>Provider:</Row>
                  <Row className='order-val'>
                    {patient?.surgeon?.name ? patient.surgeon.name : 'NA'}
                  </Row>

                  <Row className='order-label'>Surgery Date:</Row>
                  <Row className='order-val'>
                    {patient?.surgery?.date
                      ? moment(patient.surgery.date).format('MM/DD/YYYY')
                      : 'NA'}
                  </Row>

                  <Row className='order-label'>Order Date:</Row>
                  <Row className='order-val'>
                    {createdAt
                      ? moment(createdAt)
                          .format('MM/DD/YYYY, h:mm A')
                          .toString()
                      : 'NA'}
                  </Row>
                  <Row className='order-label'>Registered:</Row>
                  <Row className='order-val'>
                    {patient && props.fullfillmentDevices?.patient?.registered
                      ? 'Yes'
                      : 'No'}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </fieldset>
      </>
    )
  }
  const handleGateway = () => {
    console.log('gateway.url', gateway.url)
    if (gateway.url && gateway.url != '' && gateway.url != 'NA')
      gatewayIdPrompt()
    setGateway({ ...gateway, edit: true })
  }

  const isValidUrl = () => {
    try {
      const urlData = decodeURI(tracking.url)
      new URL(urlData)
      setTrackingErrorMsg('')
      return true
    } catch (error) {
      setTrackingErrorMsg('Invalid URL')
      return false
    }
  }
  const isValidGateway = (value) => {
    try {
      let regex = /^[a-zA-Z0-9\s-]{12,}$/ // atleast 12 characters
      if (!regex.test(value)) {
        throw new Error(`Gateway ID should be atleast 12 characters. 
                    Allowed characters: (0-9, a-z, A-Z,/\s,-).`)
      }
      value = value ? value.replaceAll(' ', '').replaceAll('-', '') : ''
      regex = /^[a-zA-Z0-9]{12}$/ // only 12 alphanumric characters are allowed
      if (!regex.test(value)) {
        throw new Error(
          'Gateway ID should be exactly 12 alphanumeric characters (0-9, a-z, A-Z).'
        )
      }
      setGatewayErrorMsg('')
      return true
    } catch (error) {
      setGatewayErrorMsg(error.message)
      return false
    }
  }

  const renderMarkAsShipped = () =>(
  <Button
    className={`msg-back-button ${!props.fullfillmentDevices?.patient?.active ? ' disable-link' : ''}`} 
      // disabled={props.fullfillmentRequests?.key?.length>0? false: true}
    onClick={handleShipped}
    >
      Mark As Shipped
  </Button>    
  )
  const closeGatewayBtn = () => {
    setGateway({ url: props.fullfillmentDevices.gateway_id, edit: false })
    setGatewayErrorMsg('')
  }
  const validAllRequiredField = () => {
    if (isTracPatch) {
      return !!(tracpatch.white_short && tracpatch.blue_short && tracpatch.leg_side && tracking.url && !trackingErrorMsg)
    }
    if (gateway.url && tracking.url && gatewayErrorMsg == '') return true
    return false
  }
  const getTooltipMessage = () => {
    if (!props.fullfillmentDevices?.patient?.active) return 'This patient is inactive'
    if (
      props.fullfillmentRequests?.key?.length > 0 &&
      validAllRequiredField()
    ) {
      return '' // No tooltip when valid
    }
    return !validAllRequiredField()
      ? isTracPatch
        ? 'Fill in WHITE serial, BLUE serial, Leg Side and Tracking URL'
        : 'Fill Gateway ID and Tracking URL'
      : 'Please select at least one device from the list above to order'
  }

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Col className='userContainer'>
          <Breadcrumb style={{ marginBottom: '2vh' }}>
            <Breadcrumb.Item>
              <Link to='/fulfillment' style={{ color: 'blue' }}>
                Fulfillment
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{fulfillmentid}</Breadcrumb.Item>
          </Breadcrumb>
          <Row className={'actionRow'}>
            <Row className={'headerText'} style={{ width: '100%' }}>
              <Col span={12}> Fullfillment Detail</Col>
              <Col span={12} align='end'>
                <Button
                  className='msg-back-button'
                  style={{ margin: 0 }}
                  onClick={() => history.push('/fulfillment')}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </Row>
          <Row>
            <Col span={1}></Col>
            <Col span={22}>
              <Row flex={'100%'} gutter={[24, 24]} className='fulfillment-row'>
                <Col span={12}>
                  {props.fullfillmentDevices && renderOrderDetails()}
                </Col>
                <Col align='right' span={12}>
                  {props.fullfillmentDevices?.patient?.shipaddress &&
                    renderShipping()}
                </Col>
              </Row>
              <Col span={24} className='fulfillment-row'>
                <Row className='header-text '> Devices</Row>
                <Row flex={'100%'} style={{ marginBottom: 10 }}>
                  <FullfillmentViewTable />
                </Row>
              </Col>

              <Row flex={'100%'} gutter={[8, 8]} className='fulfillment-row'>
                <Col span={12}>
                  {isTracPatch ? (
                    <Col span={24}>
                      <Row className='header-text'>
                        <span className='fulfillment-required'>*</span>TracPatch Serials
                      </Row>
                      <Row gutter={[0, 8]} style={{ marginTop: 8 }}>
                        <Col span={24}>
                          <Row align='middle' gutter={8}>
                            <Col style={{ width: 110 }}>TPF (WHITE)</Col>
                            <Col flex='auto'>
                              <Input
                                className='gateway-id order-input'
                                value={tracpatch.white_short}
                                maxLength={4}
                                placeholder='Last 4 chars e.g. 993E'
                                onChange={(e) =>
                                  setTracpatch({ ...tracpatch, white_short: e.target.value })
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row align='middle' gutter={8}>
                            <Col style={{ width: 110 }}>TPT (BLUE)</Col>
                            <Col flex='auto'>
                              <Input
                                className='gateway-id order-input'
                                value={tracpatch.blue_short}
                                maxLength={4}
                                placeholder='Last 4 chars e.g. 7A2B'
                                onChange={(e) =>
                                  setTracpatch({ ...tracpatch, blue_short: e.target.value })
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col span={24}>
                          <Row align='middle' gutter={8}>
                            <Col style={{ width: 110 }}>Leg Side</Col>
                            <Col>
                              <Button
                                type={tracpatch.leg_side === 'left' ? 'primary' : 'default'}
                                onClick={() => setTracpatch({ ...tracpatch, leg_side: 'left' })}
                              >
                                Left
                              </Button>
                            </Col>
                            <Col>
                              <Button
                                type={tracpatch.leg_side === 'right' ? 'primary' : 'default'}
                                onClick={() => setTracpatch({ ...tracpatch, leg_side: 'right' })}
                              >
                                Right
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  ) : (
                    <Col span={24}>
                      <Row className='header-text'>
                        {' '}
                        <span className='fulfillment-required'>*</span>Gateway ID
                        {!gateway.edit && (
                          <span style={{ marginLeft: 10 }}>
                            {props.fullfillmentDevices?.gateway_id && !props.fullfillmentDevices.isnew && (
                              <EditOutlined size={16} onClick={handleGateway} />
                            )}
                          </span>
                        )}
                        {!gateway.edit && (
                          <>
                            <span style={{ marginLeft: 10 }}>
                              <CopyOutlined onClick={copyGateway} />
                            </span>
                            {copied.gateway && (
                              <Text className='copied-text'>Gateway Id Copied!</Text>
                            )}
                          </>
                        )}
                        {gateway.edit && (
                          <>
                            <span style={{ marginLeft: 10 }}>
                              <CheckCircleFilled
                                onClick={() =>
                                  !gatewayErrorMsg && setGateway({ url: gateway.url, edit: false })
                                }
                              />
                            </span>
                            <span style={{ marginLeft: 10 }}>
                              <CloseCircleOutlined onClick={closeGatewayBtn} />
                            </span>
                          </>
                        )}
                      </Row>
                      {!props.fullfillmentDevices?.gateway_id || gateway.edit ? (
                        <Row flex='100%'>
                          <Col span={20}>
                            <Input
                              className='gateway-id order-input'
                              value={gateway.url}
                              onChange={(e) => {
                                setGateway({ ...gateway, url: e.target.value })
                                isValidGateway(e.target.value)
                              }}
                            />
                          </Col>
                          {gatewayErrorMsg && (
                            <Col span={20} className='fulfillment-required'>
                              {gatewayErrorMsg}
                            </Col>
                          )}
                        </Row>
                      ) : (
                        <Row>
                          <Col span={20} className='gateway-id input-disabled'>
                            {gateway?.url ? gateway.url : ''}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  )}
                  <Col span={24}>
                    <Row className='header-text'>
                      {' '}
                      <span className='fulfillment-required'>*</span>Tracking
                      URL
                      {/* {!tracking.edit && <>
                                                <span style={{ marginLeft: 10 }}><EditOutlined size={16} onClick={() => setTracking({ ...tracking, edit: true })} />
                                                </span>
                                            </>} */}
                      {tracking.edit && (
                        <>
                          {/* <span style={{ marginLeft: 10 }} ><CheckCircleFilled onClick={handleDeviceOrder} /></span>
                                                    <span style={{ marginLeft: 10 }} ><CloseCircleOutlined onClick={() => setTracking({
                                                        url: props.fullfillmentDevices?.tracking_link ? props.fullfillmentDevices.tracking_link : "",
                                                        edit: false
                                                    })} />
                                                    </span> */}
                        </>
                      )}
                    </Row>
                    {/* {!tracking.edit ? (
                                            <Row >
                                                <Col span={20} className="gateway-id input-disabled">
                                                    {props.fullfillmentDevices?.tracking_link ? props.fullfillmentDevices.tracking_link : "NA"}
                                                </Col>
                                            </Row>
                                        ) :
                                            <> */}
                    <Row flex='100%'>
                      <Col span={20}>
                        <Input
                          className='gateway-id order-input'
                          value={tracking.url}
                          onBlur={isValidUrl}
                          onChange={(e) => {
                            setTracking({ ...tracking, url: e.target.value })
                          }}
                        />
                      </Col>
                      {trackingErrorMsg && (
                        <Col span={20} className='fulfillment-required'>
                          {trackingErrorMsg}
                        </Col>
                      )}
                    </Row>

                    {/* </>} */}
                  </Col>
                </Col>
                <Col span={12}>
                  <Row className='header-text'>
                    {' '}
                    Note
                    {/* {!note.edit && <>
                                            <span style={{ marginLeft: 10 }}>
                                                <EditOutlined size={16} onClick={() => setNote({ ...note, edit: true })} />
                                            </span>
                                        </>} */}
                    {/* {note.edit && <>
                                            <span style={{ marginLeft: 10 }} ><CheckCircleFilled onClick={handleDeviceOrder} /></span>
                                            <span style={{ marginLeft: 10 }} ><CloseCircleOutlined onClick={() => setNote({ note: props.fullfillmentDevices?.note ? props.fullfillmentDevices.note : "", edit: false })} />
                                            </span>
                                        </>} */}
                  </Row>
                  {/* {!note.edit ? (
                                        <Row >
                                            <Col span={24} className="gateway-id note input-disabled">
                                                {props.fullfillmentDevices?.note ? props.fullfillmentDevices.note : "NA"}
                                            </Col>
                                        </Row>
                                    ) :
                                        <> */}
                  <Row flex='100%'>
                    <Col span={24}>
                      <TextArea
                        rows={4}
                        className='note-textarea order-input'
                        value={note.note}
                        onChange={(e) => {
                          setNote({ ...note, note: e.target.value })
                        }}
                      />
                    </Col>
                  </Row>

                  {/* </>} */}
                  <Row justify='end' id="tooltip-container">
                    {/* <Button className="msg-back-button cancel-btn" >Cancel</Button> */}

                    {getTooltipMessage()?.length>0?
                    <Tooltip
                      placement='topRight'
                      title={getTooltipMessage()}
                      autoAdjustOverflow={true}
                      getPopupContainer={() => document.getElementById('tooltip-container')}
                      open={getTooltipMessage()?.length>0}
                    >
                    {renderMarkAsShipped()}
                    </Tooltip>: 
                    renderMarkAsShipped()
                     }

                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Col>
      </Spin>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.device.isLoading,
    fullfillmentDevices: state.device.fullfillmentDevices,
    fullfillmentRequests: state.message.fullfillmentRequests,
    activeDevices: state.patient.activeDevices,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    messageGroupBy: (data) => dispatch(messageGroupBy(data)),
    getFullfillmentViewDevices: (params) =>
      dispatch(getFullfillmentViewDevices(params)),
    setFullfillmentDevices: (params) =>
      dispatch(setFullfillmentDevices(params)),
    updateDeviceOrder: (params) => dispatch(updateDeviceOrder(params)),
    markAsShipped: (params) => dispatch(markAsShipped(params)),
    onRowSelect: (rows) => dispatch(FullfillmentRowSelect(rows)),
    updateAddress: (params) => dispatch(updateAddress(params)),
    getActiveAssignedDevices: (params) => dispatch(getActiveAssignedDevices(params)),
    updateTracPatchFulfillment: (params) => dispatch(updateTracPatchFulfillment(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FullfillmentView)
